import formatter from './linear';

export default function (data) {
  return formatter(data, 'line');
}
